export const dashboard_routes = [
  {
    path: "/dashboard",
    component: () => import("../Main.vue"),
    name: "Dashboard"
  }
];

export default {};
